import React, { useState } from 'react';
import API from '../services/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await API.post("/farmer/login", form);

    localStorage.setItem("token", res.data.token);
    localStorage.setItem(
      "farmer",
      JSON.stringify(res.data.farmer)
    );

    toast.success("Login successful!");

    setTimeout(() => {
      window.location.href = "/dashboard";
    }, 1000);

  } catch (err) {
    console.log(err);
    toast.error(
      err.response?.data?.message || "Login failed"
    );
  }
};

  return (
    <div className="auth-bg">
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <div className="col-md-5">
            <div className="card shadow-lg border-0 auth-card">
              <div className="card-body p-5">
                <h2 className="text-center text-success mb-4 fw-bold">
                  Farmer Login
                </h2>

                <form onSubmit={handleSubmit}>
                  <input
                    type="email"
                    name="email"
                    className="form-control mb-3"
                    placeholder="Email"
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="password"
                    name="password"
                    className="form-control mb-3"
                    placeholder="Password"
                    onChange={handleChange}
                    required
                  />

                  <button className="btn btn-success w-100 py-2">
                    Login
                  </button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;